var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamAdvisoryTrim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#12D5D7;}\n\t.st2{fill:none;stroke:#26282F;stroke-width:3;stroke-linecap:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style-guide"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logos_onDark",
    transform: "translate(-780.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGWhiteLogo_Advisory_onDark",
    transform: "translate(780.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M82.5,32.5c-33,5.8-55.7,35.7-53.5,68.6c-2.2-0.5-4.4-1.1-6.5-1.8 c-0.7-17.5,5-35.4,17.4-49.7c12.4-14.3,29.3-22.4,46.7-24.2l0.3,0c1,2,1.9,4.1,2.7,6.3C87.3,31.8,84.9,32.1,82.5,32.5z  M87.5,167.6c-14.5-1.3-28.7-7-40.5-17.3c-9.9-8.6-16.8-19.3-20.8-30.8c2.3,0.5,4.7,0.8,7,1c8.7,22.7,29.4,38.6,53.1,41.5 C86.7,163.9,87,165.8,87.5,167.6z M165.3,99.3c-0.6,15.7-6.3,31.3-17.5,44.1c-11.1,12.8-25.8,20.7-41.3,23.4 c-0.5-1.7-1-3.5-1.3-5.3c0,0,0,0,0.1,0c31-5.5,53-32.3,53.6-62.8C161,98.8,163.2,99,165.3,99.3z M163.5,80.3 c-2.3-0.2-4.5-0.3-6.8-0.3c-6.3-23.4-24.7-40.9-47.1-46.5c-0.5-2.4-1.2-4.8-2-7.1c11.9,2.3,23.4,7.7,33.2,16.2 C152.5,52.9,160.2,66.2,163.5,80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_00000128463027797428351270000001816606068329501870_",
    className: "st0",
    d: "M164.6,145.3 c25.2-36,18.6-84.8-13.9-112.9c2.3-1.5,4.7-2.8,7.2-4.1c16.8,15.5,27.9,37.2,29.6,61.9c1.7,24.6-6.3,47.6-20.7,65.3l-0.2,0.3 c-2.7-0.9-5.3-1.9-7.9-3.1C160.8,150.3,162.8,147.8,164.6,145.3z M35.3,25.2C49.8,13,68.1,5.2,88.4,3.8 c17-1.2,33.2,2.3,47.4,9.3c-2.5,1.7-4.9,3.5-7.2,5.4C99.8,6,66.5,10.6,42.2,29.9C40,28.2,37.7,26.6,35.3,25.2z M26.7,159.8 c-13.9-15-23-34.7-24.5-56.7c-1.5-22,4.7-42.8,16.4-59.6c2.4,1.3,4.6,2.7,6.8,4.2l-0.1,0.1l0,0C1.8,81.3,6,125.9,32.9,154.6 C31,156.5,28.9,158.2,26.7,159.8z M45.8,175.6c2.2-1.8,4.3-3.7,6.3-5.7c27.4,16.1,60.7,15.1,86.7-0.5c2.6,1.6,5.3,3.1,8,4.5 c-13.1,8.8-28.6,14.4-45.4,15.6C81.1,190.9,61.9,185.6,45.8,175.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(86.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Communication_1956387",
    transform: "translate(0.746032, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M7.4-32.4C-15-32.4-33-18-33-0.4c0,6,2.1,11.9,6.1,17c-1.6,3-3.7,6.4-6.1,9.2 c-1.9,2.1-2.3,5.3-0.7,7.8c1.2,2.1,3.3,3.4,5.6,3.4c0.3,0,0.9,0,1.2-0.2c8.1-1.6,15.8-4.6,21-7.1c4.2,1.2,8.8,1.8,13.3,1.8 c22.4,0,40.4-14.4,40.4-32S29.6-32.4,7.4-32.4z M7.4,24.3c-4.4,0-8.6-0.5-12.6-1.8c-0.9-0.2-1.8-0.2-2.6,0.2 c-4.7,2.3-11.5,5.3-18.9,6.9c3.1-3.9,5.6-8.5,7.4-11.7c0.7-1.4,0.5-3-0.5-4.1c-3.8-4.1-5.9-8.9-5.9-14 c0-13.7,14.9-24.7,33.4-24.7S40.6-14.1,40.6-0.4S25.8,24.3,7.4,24.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000088831385750965545160000007184610339822758277_",
    className: "st1",
    d: "M18.8-11.2c-2.9-2.7-6.9-4.4-11.2-4.4 s-8.4,1.7-11.2,4.4C-6.5-8.5-8.3-4.8-8.3-0.6c0,4,1.7,7.7,4.4,10.4c0.1,0.1,0.1,0.1,0.2,0.2c2.9,2.7,6.8,4.4,11.2,4.4 s8.4-1.7,11.2-4.4c2.9-2.7,4.6-6.5,4.6-10.6S21.7-8.5,18.8-11.2L18.8-11.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(35.746032, 27.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    className: "st2",
    x1: -34.4,
    y1: -28,
    x2: -29.6,
    y2: -23.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_00000086666109174167233490000013925362755144804764_",
    className: "st2",
    x1: -20.7,
    y1: -32,
    x2: -29.4,
    y2: -23.2
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamAdvisoryTrim);
export default __webpack_public_path__ + "static/media/FAM_advisory_trim.439e3d9f5ddbd8278de462f4f04b634b.svg";
export { ForwardRef as ReactComponent };